<template>
    <Layout
        icon="click-error.svg"
        @keydown.stop="handleKeydown"
    >
        <EmptySpace />
        <PageHeader
            :title="t('views.widget.close_widget.title')"
            :description="t('views.widget.close_widget.description')"
        />
        <template #actions>
            <PlainActionsBar :actions="actions" />
        </template>
    </Layout>
</template>

<script setup lang="ts">
import EmptySpace from 'widget-components/components/EmptySpace/EmptySpace.vue'
import PlainActionsBar from '@/components/PlainActionsBar.vue'
import Layout from '@/components/Layout.vue'
import PageHeader from '@/components/PageHeader.vue'
import { useI18n } from '@/composables/i18n/useI18n'
import type { Action } from '@/components/ActionsBar.vue'
import useEmbed from '@/embed/code'
import useTracker from '@/composables/tracker/useTracker'
import useWidgetViewManager from '@/composables/widget-view-manager/useWidgetViewManager'
import { onMounted } from 'vue'

const routeName = 'close-widget'
const { track } = useTracker('', 'widget')
const { currentViewOptions, goToPreviousView } = useWidgetViewManager()
const { closeWidget } = useEmbed()

const { t } = useI18n()

onMounted(() => {
    document.querySelector<HTMLButtonElement>('[type="button"]')?.focus()
})

const cancelClose = () => {
    track('widgetClosedCancelled', routeName, {
        referringRoute: currentViewOptions.value.previousView,
    })
    goToPreviousView()
}

const handleKeydown = (event: KeyboardEvent) => {
    if (event.key === 'Escape') {
        cancelClose()
    }
}

const actions: Action[] = [{
    label: t('common.button_cancel'),
    callback: cancelClose,
}, {
    label: t('common.button_close'),
    secondary: true,
    callback: () => closeWidget(),
}]

</script>
